module.exports = __webpack_public_path__ + "img/广告-5 - 抚琴退敌.05709a3c.jpg";